import { useEffect, useRef, useState } from 'preact/hooks';
import { isErrorCase, rmErrorParamsAndReload } from '../components/app.util';

const useRefresh = () => {
  useEffect(() => {
    const userRefreshed = sessionStorage.getItem('userRefreshed');

    const rmSession = () => sessionStorage.setItem('userRefreshed', 'false');

    if (userRefreshed === 'true') {
      rmErrorParamsAndReload();
      rmSession();
    }

    const onBeforeUnload = () => {
      rmSession();
      if (isErrorCase()) {
        sessionStorage.setItem('userRefreshed', 'true');
      }
    };

    window.addEventListener('beforeunload', onBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, []);
};

export default useRefresh;
